import { styled } from '@mui/material/styles';
import RadioGroup from '@mui/material/RadioGroup';
import { ModalBase } from '@components/Modal';

export const Modal = styled(ModalBase)({
    '& .modal-base-paper': {
        outline: 'none',
        width: 564,
    },
    '& .modal-base-content': {
        padding: '24px 16px',
    },
});

export const Content = styled('div')({
    display: 'grid',
    gridGap: '16px 24px',
    gridTemplateColumns: 'minmax(0, 1fr) minmax(0, 1fr)',
    '& .companies-autocomplete': {
        marginBottom: 16,
        marginTop: 8,
    },
    '@media (max-width: 768px)': {
        gridTemplateColumns: '100%',
        gridGap: '8px',
    },
});

export const StyledRadioGroup = styled(RadioGroup)({
    flexDirection: 'row',
    alignItems: 'center',
    '& .MuiFormControlLabel-root': {
        marginRight: 0,
        marginLeft: '-3px !important',
    },
});
